import { useEffect, useRef } from 'react';
import { createConfiguratorEngine } from './engine';

export const ConfiguratorScene = ({ design, product, finish, dimensions, photoState, apiRef, onReady, onError, onPlacement }) => {
  const host = useRef(), engine = useRef(), snapshot = useRef(), callbacks = useRef();
  snapshot.current = { design, product, finish, dimensions, photoState }; callbacks.current = { onReady, onError, onPlacement };
  useEffect(() => {
    try {
      engine.current = createConfiguratorEngine(host.current, () => callbacks.current.onReady(), message => callbacks.current.onError(message), patch => callbacks.current.onPlacement?.(patch));
      apiRef.current = engine.current;
      const value = snapshot.current; engine.current.update(value.design, value.product, value.finish, value.dimensions, value.photoState);
    } catch (error) { console.error(error); callbacks.current.onError('The 3D preview could not start. Check that WebGL graphics are available in your browser.'); }
    return () => { engine.current?.dispose(); engine.current = null; apiRef.current = null; };
  }, [apiRef]);
  useEffect(() => { engine.current?.update(design, product, finish, dimensions, photoState); }, [design, product, finish, dimensions, photoState]);
  return <div ref={host} className="config-canvas-host" data-testid="config-canvas-host" />;
};